<template>
    <!-- <div class="page-header">
        <div class="form-row">
            <div class="form-group col-md-12"><h1>Account Management</h1></div>
        </div>
    </div> -->
    <CommonHeader class="main_head_block">
		<template v-slot:header>
		<span class="module_heading">Account Management</span>
        </template>
	</CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
	name:'AddVendorHeader',
    components:{
        CommonHeader
    }
}
</script>

<style lang="scss">

</style>
